import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { Testimonial } from './../models/index';

@Injectable()
export class TestimonialService {
  constructor(
    private apiCallService: ApiCallService
  ) { }

  getTestimonials(): Promise<Testimonial[]> {
    return this.apiCallService.get('/testimonials');
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/testimonial.service.ts